PersonneValidator.$inject = ['validator'];

export default function PersonneValidator(validator) {
	const instance = new validator();
	instance.ruleFor('code').notEmpty().when(isNotCodeAuto).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('code').lengthBetweenValues(1, 15).when(isNotCodeAuto).withMessage('VALIDATION_TOO_LONG_15');
	instance
		.ruleFor('code')
		.matches(/^[a-zA-Z0-9_|]*$/)
		.when(isNotCodeAuto)
		.withMessage('CODE_CHARACTERS_NOK');

	instance.ruleFor('nom').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('nom').lengthBetweenValues(0, 100).withMessage('VALIDATION_TOO_LONG_100');
	instance.ruleFor('prenom').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('prenom').lengthBetweenValues(0, 100).withMessage('VALIDATION_TOO_LONG_100');
	instance.ruleFor('idType').notEmpty().when(isPersonne).withMessage('VALIDATION_MISSING_TYPE');

	//Matches conditionnels, vides autorisés
	instance.ruleFor('mail').emailAddress().when(isCompleted).withMessage('VALIDATION_EMAIL');
	/*instance.ruleFor('telFixe').matches(/(0|\+33)\d{9}/).when(isCompleted).withMessage('VALIDATION_PHONE');
	instance.ruleFor('telMobile').matches(/(0|\+33)\d{9}/).when(isCompleted).withMessage('VALIDATION_PHONEMOBILE'); */

	instance.ruleFor('login').notEmpty().when(isUtilisateur).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('login').length(1, 50).when(isUtilisateur).withMessage('VALIDATION_TOO_LONG_50');
	instance
		.ruleFor('login')
		.matches(/^[a-zA-Z0-9_|]*$/)
		.when(isUtilisateur)
		.withMessage('UTILISATEURS.LOGIN_CHARACTERS_NOK');

	instance.ruleFor('password').notEmpty().when(modeCreation).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('passwordConfirm').notEmpty().when(modeCreation).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('passwordConfirm').must(confirmPassword).when(modeCreation).withMessage('UTILISATEURS.PASSWORD_NOT_SAME');

	instance.ruleFor('automaticPassword').lengthBetweenValues(0, 50).when(isUtilisateur).withMessage('VALIDATION_TOO_LONG_50');
	instance.ruleFor('showEvolutions').lengthBetweenValues(0, 25).when(isUtilisateur).withMessage('VALIDATION_TOO_LONG_25');

	return instance;

	function isUtilisateur(obj, _prop) {
		return obj.isUtilisateur;
	}

	function isPersonne(obj, _prop) {
		return obj.isPersonne;
	}

	function isCompleted(_obj, prop) {
		return prop != null && typeof prop !== undefined && prop != '';
	}

	function confirmPassword(obj, prop) {
		if (obj && prop) {
			return obj.password === prop;
		}

		return true;
	}

	function modeCreation(obj, _prop) {
		if (!obj.id && obj.isUtilisateur) {
			return true;
		}
		return false;
	}

	function isNotCodeAuto(obj, _prop) {
		return !obj.isCodeAutoEnabled;
	}
}
